import { ref } from 'vue'

import type { SortableMove } from './types'

export function reorderItems<T>(items: readonly T[], from: number, to: number): T[] {
  if (from === to || from < 0 || to < 0 || from >= items.length || to >= items.length) {
    return [...items]
  }

  const reordered = [...items]
  const [moved] = reordered.splice(from, 1)
  if (moved === undefined) return [...items]
  reordered.splice(to, 0, moved)
  return reordered
}

export function useSortable<T>(items: () => readonly T[]) {
  const sourceIndex = ref<number | null>(null)
  const targetIndex = ref<number | null>(null)

  function begin(index: number): void {
    sourceIndex.value = index
    targetIndex.value = index
  }

  function over(index: number): void {
    if (sourceIndex.value !== null) targetIndex.value = index
  }

  function cancel(): void {
    sourceIndex.value = null
    targetIndex.value = null
  }

  function drop(index = targetIndex.value): SortableMove<T> | null {
    const from = sourceIndex.value
    const to = index
    cancel()
    if (from === null || to === null || from === to) return null
    return { from, to, items: reorderItems(items(), from, to) }
  }

  return { sourceIndex, targetIndex, begin, over, drop, cancel }
}
